import React from 'react';
import './blog-post.css';
import Pinterest1 from './pictures/Pinterest1.png';
import Pinterest2 from './pictures/Pinterest2.png';
import Pinterest3 from './pictures/Pinterest3.png';
//import reportWebVitals from './reportWebVitals';

const Pinterest = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Women in Tech Panel with Pinterest Recap</h2>
                    <p class="site-post-meta">October 18th, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    We hosted a Pinterest Women in Tech Panel with two software engineers who are UW alums and 
                    one incoming software engineer currently at UW!
                    WiC members learned about what it is like to work at Pinterest, Pinterest’s culture, 
                    and the career journeys of the panelists. 
                    Attendees had the opportunity to interact with Pinterest recruiters and the 
                    software engineers, asked questions, 
                    and learned about the different areas of software engineering at Pinterest.
                    Thank you so much to everyone who attended - we hope you learned a lot about 
                    software engineering opportunities at Pinterest!
                    </p>
                    <img src={Pinterest1} alt="Pinterst panelists introduction"/>
                    <img src={Pinterest2} alt="Pinterest Q&A Session"/>
                    <img src={Pinterest3} alt="Thank you to the panelists"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Pinterest;

